<div class="free-text-question-widget">
  @if (question) {
    <p [innerHTML]="question | safeHtml"></p>
  }

  <mat-form-field class="gray-form-field form-field-textarea w-100" appearance="outline">
    <textarea
      [(ngModel)]="answer"
      (ngModelChange)="answerChanged()"
      matInput
      cdkTextareaAutosize
      cdkAutosizeMinRows="1"
      cdkAutosizeMaxRows="5"
      placeholder="{{'QUIZ.your_answer' | translate}}">
    </textarea>
  </mat-form-field>

</div>